import { Link } from 'react-router-dom';
import { styled } from 'styled-components';
import { srOnly } from 'app/visuals/mixins/srOnly';

export const BlastingScenarioBackLink = styled(Link)`
  display: block;
  text-align: center;
  color: ${({ theme }) => theme.colors.mono.text01} !important;
  font-size: 1.4rem;
  margin-bottom: ${({ theme }) => theme.spacing(3)}px;

  &:hover {
    color: ${({ theme }) => theme.colors.mono.text01};
    text-decoration: none;
  }

  svg {
    vertical-align: middle;
    margin-right: ${({ theme }) => theme.spacing(0.5)}px;
  }
`;

export const RemoveSimulationTimeButton = styled.button`
  margin: auto;
`;

export const SimulationTimeFieldWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing(2)}px;
`;

export const HiddenBlastTimeLabel = styled.label`
  ${() => srOnly}
`;

export const BlastingButton = styled.button`
  color: ${({ theme }) => theme.colors.mono.text03};
  font-size: 1.4rem;
  display: flex;
  align-items: center;
  &:disabled {
    cursor: not-allowed;
  }
  &:hover:not(:disabled) {
    color: ${({ theme }) => theme.colors.mono.text01};
  }
  & svg {
    color: ${({ theme }) => theme.colors.mono.text01};
  }
`;

export const BlastingButtonText = styled.span`
  display: inline-block;
  margin-left: ${({ theme }) => theme.spacing()}px;
`;
